import React, { Fragment, useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "./../CustomedFields/FormikControl";
import measurementSettingsDetailsServices from "../../services/measurementSettingsDetailsServices";
import roMeasurementSave from "../../Models/roMeasurementSave";
import _measurementService from "./../../services/measurementServices";

// React Notification
import { NotificationManager } from "react-notifications";

// function CustomerAdd(props, ref) {
const AddEditSingleMeasurement = React.forwardRef((props, ref) => {
  const [settingsDetails, setSettingsDetails] = useState([]);

  const initialValues = {
    MeasurementComments: "",
    // CellNo: "",
    // AlternetPhone: "",
    // Email: "",
    // Address: "",
  };

  const validationSchema = Yup.object({
    MeasurementComments: Yup.string().required("Required"),
    // CellNo: Yup.string().required("Required"),
    // Email: Yup.string().email("Invalid email format"),
  });

  const onSubmit = (values) => {
    console.log("Form data " + values);
    // alert("add customer submit");
    // props.AddCustomerToDB(values);
    // debugger;
    let roMeasurementToSave = new roMeasurementSave();
    roMeasurementToSave.CustomerID_GUID = props.customerGUID;
    roMeasurementToSave.ProductItemID_GUID = props.selectedProductItemGUID; //
    roMeasurementToSave.MeasurementSettingsID_GUID = props.settingsID;
    roMeasurementToSave.innerObj = values;
    console.log("roMeasurementToSave :" + roMeasurementToSave);

    let result =
      _measurementService.saveMeasurementAndMeasurementDetails(
        roMeasurementToSave
      );

    NotificationManager.success(
      "You have added a new book!",
      "Successful!",
      4000
    );
    console.log("result : " + result);
  };

  //********************* Form validation send to Parent form */
  //   React.useEffect(() => {
  //     // Update the document title using the browser API
  //     // alert("document.getElementById(submitButton).disabled");
  //     props.isValidChildFormInputs(
  //       document.getElementById("submitButton")?.disabled
  //     );
  //   }, [document.getElementById("submitButton")?.disabled]);

  // *****************   Get measurement settings Deails by measurement settings ID       ****************
  useEffect(() => {
    //(a) Get all measurement settings to load DDL
    async function fetchAllSettings() {
      try {
        //  alert("called api");
        let measurementSettingsAll =
          await measurementSettingsDetailsServices.getBySettingsID(
            props.settingsID
          );
        //  alert("called api done : " + measurementSettingsAll.length);

        console.log(
          "measurementSettingsAll : " + measurementSettingsAll.length
        );
        setSettingsDetails(measurementSettingsAll);
        console.log("settingsDetails : " + settingsDetails.length);
      } catch (e) {
        console.error(e);
      }
    }
    fetchAllSettings();
  }, [props.settingsID]);

  return (
    <Fragment>
      <div className="card">
        <div className="card-body">
          <div className="media media-reply">
            <div className="media-body">
              <div className="d-sm-flex justify-content-between mb-2">
                <h5 className="mb-sm-0">
                  {props.productItemName}({props.settingsName})
                  <small className="text-muted ml-3">about 3 days ago</small>
                </h5>
                <div className="media-reply__link">
                  <ul className="mb-0 form-profile__icons">
                    <li className="d-inline-block">
                      <button className="btn btn-transparent p-0 mr-3">
                        <i className="fa fa-user"></i>
                      </button>
                    </li>
                    <li className="d-inline-block">
                      <button className="btn btn-transparent p-0 mr-3">
                        <i className="fa fa-paper-plane"></i>
                      </button>
                    </li>
                    <li className="d-inline-block">
                      <button className="btn btn-transparent p-0 mr-3">
                        <i className="fa fa-camera"></i>
                      </button>
                    </li>
                    <li className="d-inline-block">
                      <button className="btn btn-transparent p-0 mr-3">
                        <i className="fa fa-smile"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {(formik) => {
                  return (
                    <Form>
                      <FormikControl
                        control="input"
                        type="text"
                        label="Name Of Measurement" //keep at comments Field at DB
                        name="MeasurementComments"
                      />

                      {settingsDetails.map((item, index) => {
                        return (
                          <FormikControl
                            control="input"
                            type="text"
                            label={item.fieldName}
                            name={item.measurementSettingsDetailsID_GUID}
                          />
                        );
                      })}
                      <button
                        id="submitButton"
                        type="submit"
                        disabled={!formik.isValid}
                        ref={ref}
                      >
                        Submit
                      </button>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
});

export default AddEditSingleMeasurement;
